/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=858da638"
const script = {}

import "./App.vue?vue&type=style&index=0&id=858da638&lang=less"

import exportComponent from "D:\\HBuilderProjects\\quyizu-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__